<!--
* UIID: 
* UI Name: Script List
* Modify Date: 2022/08/14
-->
<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="dialog-drag-display"
  >
    <!-- [S]  Popup title-->
    <template v-slot:title>
      <v-card-title class="headline white--text" primary-title>{{
        $t('lbl.userSimulator.scriptList.title')
      }}</v-card-title>
    </template>
    <template v-slot:button-close>
      <!-- <v-icon class="ma-2" small @click="removeDialog" color="white">fas fa-times</v-icon> -->
      <v-btn small text icon @click="removeDialog">
        <icon-svg iconName="close" />
      </v-btn>
    </template>
    <!-- [E]  Popup title-->
    <v-card-text class="data-section pa-0 pr-8 pl-8 mr-0">
      <!-- [S]  Data Section-->
      <v-row class="ma-0 map-pb-search">
        <v-col cols="8" class="pa-0"></v-col>
        <v-col cols="1" class="map-popup-locked">
          <v-label>{{ $t('lbl.common.lockerTitle') }}</v-label>
          <div class="map-dv-select-locked">
            <v-select
              v-model="filterItems.locked"
              :items="lockedItems"
              @change="filterUserList"
              height="30"
              solo
              dense
            ></v-select>
          </div>
        </v-col>
        <v-col cols="3" class="pt-0 pb-0 pr-0 map-search">
          <v-text-field
            v-model="filterItems.search"
            @input="filterUserList"
            @click:append="filterUserList"
            @keyup.enter="filterUserList"
            class="search-matched-map-list-button custom-form-component search-button"
            placeholder="Search"
            outlined
            dense
            solo
            hide-details
            append-icon="fas fa-search"
            height="30"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row class="ma-0">
        <!-- // 203737 05/19/2021 Issue 53 No display spinner when enter Dashboard, Transaction Log and Workflow via left menu -->
        <system-progress
          :sysloading="isLoading"
          :sysloadingTitle="sysloadingTitle"
        ></system-progress>
        <v-col cols="12" class="pt-0 pr-0 pb-0 pl-0">
          <v-data-table
            :headers="SummDataList.headers"
            :items="userList"
            :items-per-page="-1"
            :hide-default-footer="true"
            :disable-sort="true"
            class="map-list-table pb-0"
            fixed-header
          >
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.uc_id">
                  <td class="map-name-col">{{ item.uc_name }}</td>
                  <td class="locked-col">
                    <v-icon
                      v-if="item.lock_yn === 'y'"
                      small
                      @click.native="releaseLockedUser(item, 'USER')"
                      >fas fa-check-square</v-icon
                    >
                    <v-icon v-if="item.lock_yn === 'n'" small>far fa-window-close</v-icon>
                  </td>
                  <!-- <td class="map-name-col">{{ item.sql_grp_nm }}</td> -->
                  <td class="version-col">
                    <a class="link-file-text" @click="openUserCompVersion(item)">{{
                      item.uc_ver
                    }}</a>
                  </td>
                  <td class="date-col no-wrap">
                    <span>{{ item.upd_dt }}</span>
                  </td>
                  <td class="customer-col">{{ item.upd_user }}</td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <!-- [E]  Data Section-->
    </v-card-text>
    <v-divider class="ml-0 mr-0 divder-popup" inset></v-divider>
    <v-row class="ml-0 mr-0">
      <v-col class="button-col action-col" lg="12">
        <div class="btn-form-control text-right mr-4">
          <v-btn class="btn btn-delete" @click="removeDialog">{{ $t('btn.common.close') }}</v-btn>
        </div>
      </v-col>
    </v-row>
    <dialogWindow
      ref="warningCheckedOutMapperDialog"
      size="max"
      :detail="
        $t('msg.common.warning.detailWarningReleaseLocked', ['mapper', updateUserId, 'Mapper'])
      "
      color="validation"
    ></dialogWindow>
  </dialog-drag>
</template>

<script>
/* globals Store */

import DialogDrag from '@/vue-dlb/components/vue-dialog-drag.vue';
import { mapState } from 'vuex';
import $ from 'jquery';
import cfg from '@/vue-caas/config/config.js';
// 203737 05/19/2021 Issue 53 No display spinner when enter Dashboard, Transaction Log and Workflow via left menu
import SystemProgress from '@/vue-dlb/components/SystemProgress.vue';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import IconSvg from '@/vue-caas/components/IconBase.vue';

/* 2020/11/11 203737 Remove unused source
import {
  showSuccessMessage,
  showErrorMessage,
  showProgress,
  hideProgress,
  alertSuccess,
  closeAlert
} from "@/vue-dlb/utils/sys-util.js";*/

export default {
  components: {
    DialogDrag,
    SystemProgress,
    dialogWindow,
    IconSvg,
  },
  name: 'maplist-dialog',
  /* 2020/10/29 203737 Change prop definitions
  props: ['id', 'title', 'options', 'eventCb','selectFile', 'closeDialog', 'dragStart', 'dragEnd', 'queryList','fileSelected'],*/
  props: {
    id: String,
    options: Object,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
  },
  watch: {
    listData() {
      return this.userList;
    },
  },
  computed: {
    // ...mapState("mapbuilder", {
    //   mapList: "mapList",
    //   appliedList: "appliedList",
    // }),
    ...mapState('common', {
      sysloadingTitle: 'sysloadingTitle',
    }),
  },
  data() {
    return {
      mapData: [],
      customerSelect: false,
      userList: [],
      masterSearchItems: {
        header: ['ADMIN_YN', 'CUST_ID', 'LOCK_YN', 'MAP_PRCS_NO'],
        data: [
          {
            ADMIN_YN: '',
            CUST_ID: '',
            LOCK_YN: '',
            MAP_PRCS_NO: '',
          },
        ],
      },
      filterItems: {
        cus: '',
        locked: '',
        search: '',
        CheckScanner: false,
      },
      SummDataList: {
        headers: [
          { text: 'User Name', value: 'uc_name' },
          { text: 'Locked', value: 'lock_yn' },
          // { text: "DB Mapper", value: "sql_grp_nm" },
          { text: 'Version', value: 'uc_ver' },
          // { text: "Customer", value: "MST_CUST_ID" },
          { text: 'Update Date', value: 'upd_dt' },
          { text: 'Update User', value: 'upd_user' },
        ],
      },
      lockedItems: [
        { text: 'All', value: '' },
        { text: 'Y', value: 'y' },
        { text: 'N', value: 'n' },
      ],
      customerItems: [
        { text: 'All', value: '' },
        { text: 'Customer', value: 'ENDUSER' },
        { text: 'Admin', value: 'ADMIN' },
      ],
      releaseLockItems: {
        header: ['MAP_KIND', 'MAP_PRCS_NO', 'LOCK_YN'],
        data: [
          {
            MAP_KIND: '',
            MAP_PRCS_NO: '',
            LOCK_YN: 'n',
          },
        ],
      },
      arrLayoutDialog: [],
      dialogs: [],
      dialogId: 1,
      isLoading: true,
      currentUserId: '',
      updateUserId: '',
    };
  },
  created() {
    this.queryUserList();
    if ($cookies.get('comp-id') == cfg.provider) {
      this.customerSelect = true;
    }
  },
  methods: {
    removeDialog(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
    releaseLockedUser(item, type) {
      Store.dispatch('toggleLocked', { uc_id: item.uc_id, lock_yn: item.lock_yn }).then(() => {
        this.queryUserList();
      });
    },
    queryUserList() {
      // 203737 05/19/2021 Issue 53 No display spinner when enter Dashboard, Transaction Log and Workflow via left menu
      this.isLoading = true;
      //[2020-04-17] apply by CLV: Apply srmlist/queryMapList api
      console.log('--------- getSummaryList ----------');
      Store.dispatch('getUserSimQueryList')
        .then(() => {
          console.log('--------- Finished to process ----------');
          this.userList = this.$store.getters.userSimList;
          this.userData = this.userList;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    filterUserList() {
      Store.commit('SET_USER_FILTER', this.filterItems);
      this.userList = this.$store.getters.userSimList;
      this.userData = this.userData;
    },
    openUserCompVersion(itemRow) {
      this.$emit('openUserCompVersion', itemRow);
    },
    openMapperVersion(itemRow) {
      let isCheckedOut = this.getIsCheckedOut(itemRow, 'MAPP');
      itemRow.isCheckedOut = isCheckedOut;
      this.$emit('openMapperVersion', itemRow);
    },
    findDialog(id, dialogs) {
      if (!dialogs) dialogs = this.dialogs;
      let index = dialogs.findIndex((val) => {
        return val.id === id;
      });
      return index > -1 ? index : null;
    },
    newDialog(item, type) {
      return this.dialogs.push(this.generateDialog(item, type));
    },
    generateDialog(item, type) {
      let id = `${type}_${item.ROWID}`;
      this.arrLayoutDialog.push({ id: id });
      this.dialogId++;
      let name = 'Dialog ' + id;
      let options = { left: 30 * this.dialogId, top: 30 * this.dialogId, item };
      return { id, name, type, options };
    },
    removeDialogVersion(dialog) {
      let id = dialog.id;
      let index = this.findDialog(id);
      let indexArrDialog = this.findDialog(id, this.arrLayoutDialog);
      this.arrLayoutDialog.splice(indexArrDialog, 1);
      this.dialogs.splice(index, 1);
      if (this.selected && this.selected.id === id) this.selected = null;
    },
    getIsCheckedOut(itemRow, type) {
      let isCheckedOut = false;
      this.currentUserId = $cookies.get('user-id');
      this.updateUserId = itemRow.MAP_UPD_USR;
      let isLocked;

      if (type === 'MAPP') {
        isLocked = itemRow.lock_yn === 'y' ? true : false;
      } else {
        isLocked = itemRow.lock_yn === 'y' ? true : false;
      }

      if (this.currentUserId !== this.updateUserId && isLocked) {
        isCheckedOut = true;
      }
      return isCheckedOut;
    },
  },
};
</script>
